// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__226Oc","inputDescription":"styles_inputDescription__262ly"};